import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface EmspBoEmspUserListActionsHeaderProps
  extends HeaderContext<EmspUserModel, unknown> {}

export const EmspBoEmspUserListActionsHeader =
  (): // props: EmspBoEmspUserListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
